module.exports = __webpack_public_path__ + "static/media/thumbnail.3a6e0297.jpg";